export const locationOptions = {
  hot: [
    {
      value: '11',
      label: '北京'
    },
    {
      value: '31',
      label: '上海'
    },
    {
      value: '12',
      label: '天津'
    },
    {
      value: '50',
      label: '重庆'
    },
    {
      value: '4401',
      label: '广州'
    }
  ],
  normal: [
    {
      value: '34',
      label: '安徽',
      code: 'A',
      scrollHeight: 0,
      city: [
        {
          cityName: '合肥',
          cityCode: '3401'
        },
        {
          cityName: '芜湖',
          cityCode: '3402'
        },
        {
          cityName: '蚌埠',
          cityCode: '3403'
        },
        {
          cityName: '淮南',
          cityCode: '3404'
        },
        {
          cityName: '马鞍山',
          cityCode: '3405'
        },
        {
          cityName: '淮北',
          cityCode: '3406'
        },
        {
          cityName: '铜陵',
          cityCode: '3407'
        },
        {
          cityName: '安庆',
          cityCode: '3408'
        },
        {
          cityName: '黄山',
          cityCode: '3410'
        },
        {
          cityName: '滁州',
          cityCode: '3411'
        },
        {
          cityName: '阜阳',
          cityCode: '3412'
        },
        {
          cityName: '宿州',
          cityCode: '3413'
        },
        {
          cityName: '六安',
          cityCode: '3415'
        },
        {
          cityName: '亳州',
          cityCode: '3416'
        },
        {
          cityName: '池州',
          cityCode: '3417'
        },
        {
          cityName: '宣城',
          cityCode: '3418'
        }
      ]
    },
    {
      value: '35',
      label: '福建',
      code: 'F',
      scrollHeight: 0,
      city: [
        {
          cityName: '福州',
          cityCode: '3501'
        },
        {
          cityName: '厦门',
          cityCode: '3502'
        },
        {
          cityName: '莆田',
          cityCode: '3503'
        },
        {
          cityName: '三明',
          cityCode: '3504'
        },
        {
          cityName: '泉州',
          cityCode: '3505'
        },
        {
          cityName: '漳州',
          cityCode: '3506'
        },
        {
          cityName: '南平',
          cityCode: '3507'
        },
        {
          cityName: '龙岩',
          cityCode: '3508'
        },
        {
          cityName: '宁德',
          cityCode: '3509'
        }
      ]
    },
    {
      value: '44',
      label: '广东',
      code: 'G',
      scrollHeight: 0,
      city: [
        {
          cityName: '广州',
          cityCode: '4401'
        },
        {
          cityName: '韶关',
          cityCode: '4402'
        },
        {
          cityName: '深圳',
          cityCode: '4403'
        },
        {
          cityName: '珠海',
          cityCode: '4404'
        },
        {
          cityName: '汕头',
          cityCode: '4405'
        },
        {
          cityName: '佛山',
          cityCode: '4406'
        },
        {
          cityName: '江门',
          cityCode: '4407'
        },
        {
          cityName: '湛江',
          cityCode: '4408'
        },
        {
          cityName: '茂名',
          cityCode: '4409'
        },
        {
          cityName: '肇庆',
          cityCode: '4412'
        },
        {
          cityName: '惠州',
          cityCode: '4413'
        },
        {
          cityName: '梅州',
          cityCode: '4414'
        },
        {
          cityName: '汕尾',
          cityCode: '4415'
        },
        {
          cityName: '河源',
          cityCode: '4416'
        },
        {
          cityName: '阳江',
          cityCode: '4417'
        },
        {
          cityName: '清远',
          cityCode: '4418'
        },
        {
          cityName: '东莞',
          cityCode: '4419'
        },
        {
          cityName: '中山',
          cityCode: '4420'
        },
        {
          cityName: '潮州',
          cityCode: '4451'
        },
        {
          cityName: '揭阳',
          cityCode: '4452'
        },
        {
          cityName: '云浮',
          cityCode: '4453'
        }
      ]
    },
    {
      value: '45',
      label: '广西',
      //"code": "G",
      scrollHeight: 0,
      city: [
        {
          cityName: '南宁',
          cityCode: '4501'
        },
        {
          cityName: '柳州',
          cityCode: '4502'
        },
        {
          cityName: '桂林',
          cityCode: '4503'
        },
        {
          cityName: '梧州',
          cityCode: '4504'
        },
        {
          cityName: '北海',
          cityCode: '4505'
        },
        {
          cityName: '防城港',
          cityCode: '4506'
        },
        {
          cityName: '钦州',
          cityCode: '4507'
        },
        {
          cityName: '贵港',
          cityCode: '4508'
        },
        {
          cityName: '玉林',
          cityCode: '4509'
        },
        {
          cityName: '百色',
          cityCode: '4510'
        },
        {
          cityName: '贺州',
          cityCode: '4511'
        },
        {
          cityName: '河池',
          cityCode: '4512'
        },
        {
          cityName: '来宾',
          cityCode: '4513'
        },
        {
          cityName: '崇左',
          cityCode: '4514'
        }
      ]
    },
    {
      value: '52',
      label: '贵州',
      //"code": "G",
      scrollHeight: 0,
      city: [
        {
          cityName: '贵阳',
          cityCode: '5201'
        },
        {
          cityName: '六盘水',
          cityCode: '5202'
        },
        {
          cityName: '遵义',
          cityCode: '5203'
        },
        {
          cityName: '安顺',
          cityCode: '5204'
        },
        {
          cityName: '毕节',
          cityCode: '5205'
        },
        {
          cityName: '铜仁',
          cityCode: '5206'
        },
        {
          cityName: '贵安新区',
          cityCode: '5209'
        },
        {
          cityName: '黔西南布依族苗族自治州',
          cityCode: '5223'
        },
        {
          cityName: '黔东南苗族侗族自治州',
          cityCode: '5226'
        },
        {
          cityName: '黔南布依族苗族自治州',
          cityCode: '5227'
        }
      ]
    },
    {
      value: '62',
      label: '甘肃',
      //"code": "G",
      scrollHeight: 0,
      city: [
        {
          cityName: '兰州',
          cityCode: '6201'
        },
        {
          cityName: '嘉峪关',
          cityCode: '6202'
        },
        {
          cityName: '金昌',
          cityCode: '6203'
        },
        {
          cityName: '白银',
          cityCode: '6204'
        },
        {
          cityName: '天水',
          cityCode: '6205'
        },
        {
          cityName: '武威',
          cityCode: '6206'
        },
        {
          cityName: '张掖',
          cityCode: '6207'
        },
        {
          cityName: '平凉',
          cityCode: '6208'
        },
        {
          cityName: '酒泉',
          cityCode: '6209'
        },
        {
          cityName: '庆阳',
          cityCode: '6210'
        },
        {
          cityName: '定西',
          cityCode: '6211'
        },
        {
          cityName: '陇南',
          cityCode: '6212'
        },
        {
          cityName: '临夏',
          cityCode: '6229'
        },
        {
          cityName: '甘南',
          cityCode: '6230'
        }
      ]
    },
    {
      value: '13',
      label: '河北',
      code: 'H',
      scrollHeight: 0,
      city: [
        {
          cityName: '石家庄',
          cityCode: '1301'
        },
        {
          cityName: '唐山',
          cityCode: '1302'
        },
        {
          cityName: '秦皇岛',
          cityCode: '1303'
        },
        {
          cityName: '邯郸',
          cityCode: '1304'
        },
        {
          cityName: '邢台',
          cityCode: '1305'
        },
        {
          cityName: '保定',
          cityCode: '1306'
        },
        {
          cityName: '张家口',
          cityCode: '1307'
        },
        {
          cityName: '承德',
          cityCode: '1308'
        },
        {
          cityName: '沧州',
          cityCode: '1309'
        },
        {
          cityName: '廊坊',
          cityCode: '1310'
        },
        {
          cityName: '衡水',
          cityCode: '1311'
        },
        {
          cityName: '雄安新区',
          cityCode: '1331'
        }
      ]
    },
    {
      value: '23',
      label: '黑龙江',
      //"code": "H",
      scrollHeight: 0,
      city: [
        {
          cityName: '哈尔滨',
          cityCode: '2301'
        },
        {
          cityName: '齐齐哈尔',
          cityCode: '2302'
        },
        {
          cityName: '鸡西',
          cityCode: '2303'
        },
        {
          cityName: '鹤岗',
          cityCode: '2304'
        },
        {
          cityName: '双鸭山',
          cityCode: '2305'
        },
        {
          cityName: '大庆',
          cityCode: '2306'
        },
        {
          cityName: '伊春',
          cityCode: '2307'
        },
        {
          cityName: '佳木斯',
          cityCode: '2308'
        },
        {
          cityName: '七台河',
          cityCode: '2309'
        },
        {
          cityName: '牡丹江',
          cityCode: '2310'
        },
        {
          cityName: '黑河',
          cityCode: '2311'
        },
        {
          cityName: '绥化',
          cityCode: '2312'
        },
        {
          cityName: '大兴安岭',
          cityCode: '2327'
        }
      ]
    },
    {
      value: '41',
      label: '河南',
      //"code": "H",
      scrollHeight: 0,
      city: [
        {
          cityName: '郑州',
          cityCode: '4101'
        },
        {
          cityName: '开封',
          cityCode: '4102'
        },
        {
          cityName: '洛阳',
          cityCode: '4103'
        },
        {
          cityName: '平顶山',
          cityCode: '4104'
        },
        {
          cityName: '安阳',
          cityCode: '4105'
        },
        {
          cityName: '鹤壁',
          cityCode: '4106'
        },
        {
          cityName: '新乡',
          cityCode: '4107'
        },
        {
          cityName: '焦作',
          cityCode: '4108'
        },
        {
          cityName: '濮阳',
          cityCode: '4109'
        },
        {
          cityName: '许昌',
          cityCode: '4110'
        },
        {
          cityName: '漯河',
          cityCode: '4111'
        },
        {
          cityName: '三门峡',
          cityCode: '4112'
        },
        {
          cityName: '南阳',
          cityCode: '4113'
        },
        {
          cityName: '商丘',
          cityCode: '4114'
        },
        {
          cityName: '信阳',
          cityCode: '4115'
        },
        {
          cityName: '周口',
          cityCode: '4116'
        },
        {
          cityName: '驻马店',
          cityCode: '4117'
        },
        {
          cityName: '济源',
          cityCode: '419001'
        }
      ]
    },
    {
      value: '42',
      label: '湖北',
      //"code": "H",
      scrollHeight: 0,
      city: [
        {
          cityName: '武汉',
          cityCode: '4201'
        },
        {
          cityName: '黄石',
          cityCode: '4202'
        },
        {
          cityName: '十堰',
          cityCode: '4203'
        },
        {
          cityName: '宜昌',
          cityCode: '4205'
        },
        {
          cityName: '襄阳',
          cityCode: '4206'
        },
        {
          cityName: '鄂州',
          cityCode: '4207'
        },
        {
          cityName: '荆门',
          cityCode: '4208'
        },
        {
          cityName: '孝感',
          cityCode: '4209'
        },
        {
          cityName: '荆州',
          cityCode: '4210'
        },
        {
          cityName: '黄冈',
          cityCode: '4211'
        },
        {
          cityName: '咸宁',
          cityCode: '4212'
        },
        {
          cityName: '随州',
          cityCode: '4213'
        },
        {
          cityName: '恩施',
          cityCode: '4228'
        },
        {
          cityName: '仙桃',
          cityCode: '429004'
        },
        {
          cityName: '潜江',
          cityCode: '429005'
        },
        {
          cityName: '天门',
          cityCode: '429006'
        },
        {
          cityName: '神农架林区',
          cityCode: '429021'
        }
      ]
    },
    {
      value: '43',
      label: '湖南',
      //"code": "H",
      scrollHeight: 0,
      city: [
        {
          cityName: '长沙',
          cityCode: '4301'
        },
        {
          cityName: '株洲',
          cityCode: '4302'
        },
        {
          cityName: '湘潭',
          cityCode: '4303'
        },
        {
          cityName: '衡阳',
          cityCode: '4304'
        },
        {
          cityName: '邵阳',
          cityCode: '4305'
        },
        {
          cityName: '岳阳',
          cityCode: '4306'
        },
        {
          cityName: '常德',
          cityCode: '4307'
        },
        {
          cityName: '张家界',
          cityCode: '4308'
        },
        {
          cityName: '益阳',
          cityCode: '4309'
        },
        {
          cityName: '郴州',
          cityCode: '4310'
        },
        {
          cityName: '永州',
          cityCode: '4311'
        },
        {
          cityName: '怀化',
          cityCode: '4312'
        },
        {
          cityName: '娄底',
          cityCode: '4313'
        },
        {
          cityName: '湘西',
          cityCode: '4331'
        }
      ]
    },
    {
      value: '46',
      label: '海南',
      //"code": "H",
      scrollHeight: 0,
      city: [
        {
          cityName: '海口',
          cityCode: '4601'
        },
        {
          cityName: '三亚',
          cityCode: '4602'
        },
        {
          cityName: '三沙',
          cityCode: '4603'
        },
        {
          cityName: '儋州',
          cityCode: '4604'
        },
        {
          cityName: '五指山',
          cityCode: '469001'
        },
        {
          cityName: '琼海',
          cityCode: '469002'
        },
        {
          cityName: '文昌',
          cityCode: '469005'
        },
        {
          cityName: '万宁',
          cityCode: '469006'
        },
        {
          cityName: '东方',
          cityCode: '469007'
        },
        {
          cityName: '定安县',
          cityCode: '469021'
        },
        {
          cityName: '屯昌县',
          cityCode: '469022'
        },
        {
          cityName: '澄迈县',
          cityCode: '469023'
        },
        {
          cityName: '临高县',
          cityCode: '469024'
        },
        {
          cityName: '白沙黎族自治县',
          cityCode: '469025'
        },
        {
          cityName: '昌江黎族自治县',
          cityCode: '469026'
        },
        {
          cityName: '乐东黎族自治县',
          cityCode: '469027'
        },
        {
          cityName: '陵水黎族自治县',
          cityCode: '469028'
        },
        {
          cityName: '保亭黎族苗族自治县',
          cityCode: '469029'
        },
        {
          cityName: '琼中黎族苗族自治县',
          cityCode: '469030'
        }
      ]
    },
    {
      value: '22',
      label: '吉林',
      code: 'J',
      scrollHeight: 0,
      city: [
        {
          cityName: '长春',
          cityCode: '2201'
        },
        {
          cityName: '吉林',
          cityCode: '2202'
        },
        {
          cityName: '四平',
          cityCode: '2203'
        },
        {
          cityName: '辽源',
          cityCode: '2204'
        },
        {
          cityName: '通化',
          cityCode: '2205'
        },
        {
          cityName: '白山',
          cityCode: '2206'
        },
        {
          cityName: '松原',
          cityCode: '2207'
        },
        {
          cityName: '白城',
          cityCode: '2208'
        },
        {
          cityName: '延边朝鲜族自治州',
          cityCode: '2224'
        }
      ]
    },
    {
      value: '32',
      label: '江苏',
      //"code": "J",
      scrollHeight: 0,
      city: [
        {
          cityName: '南京',
          cityCode: '3201'
        },
        {
          cityName: '无锡',
          cityCode: '3202'
        },
        {
          cityName: '徐州',
          cityCode: '3203'
        },
        {
          cityName: '常州',
          cityCode: '3204'
        },
        {
          cityName: '苏州',
          cityCode: '3205'
        },
        {
          cityName: '南通',
          cityCode: '3206'
        },
        {
          cityName: '连云港',
          cityCode: '3207'
        },
        {
          cityName: '淮安',
          cityCode: '3208'
        },
        {
          cityName: '盐城',
          cityCode: '3209'
        },
        {
          cityName: '扬州',
          cityCode: '3210'
        },
        {
          cityName: '镇江',
          cityCode: '3211'
        },
        {
          cityName: '泰州',
          cityCode: '3212'
        },
        {
          cityName: '宿迁',
          cityCode: '3213'
        }
      ]
    },
    {
      value: '36',
      label: '江西',
      //"code": "J",
      scrollHeight: 0,
      city: [
        {
          cityName: '南昌',
          cityCode: '3601'
        },
        {
          cityName: '景德镇',
          cityCode: '3602'
        },
        {
          cityName: '萍乡',
          cityCode: '3603'
        },
        {
          cityName: '九江',
          cityCode: '3604'
        },
        {
          cityName: '新余',
          cityCode: '3605'
        },
        {
          cityName: '鹰潭',
          cityCode: '3606'
        },
        {
          cityName: '赣州',
          cityCode: '3607'
        },
        {
          cityName: '吉安',
          cityCode: '3608'
        },
        {
          cityName: '宜春',
          cityCode: '3609'
        },
        {
          cityName: '抚州',
          cityCode: '3610'
        },
        {
          cityName: '上饶',
          cityCode: '3611'
        }
      ]
    },
    {
      value: '21',
      label: '辽宁',
      code: 'L',
      scrollHeight: 0,
      city: [
        {
          cityName: '沈阳',
          cityCode: '2101'
        },
        {
          cityName: '大连',
          cityCode: '2102'
        },
        {
          cityName: '鞍山',
          cityCode: '2103'
        },
        {
          cityName: '抚顺',
          cityCode: '2104'
        },
        {
          cityName: '本溪',
          cityCode: '2105'
        },
        {
          cityName: '丹东',
          cityCode: '2106'
        },
        {
          cityName: '锦州',
          cityCode: '2107'
        },
        {
          cityName: '营口',
          cityCode: '2108'
        },
        {
          cityName: '阜新',
          cityCode: '2109'
        },
        {
          cityName: '辽阳',
          cityCode: '2110'
        },
        {
          cityName: '盘锦',
          cityCode: '2111'
        },
        {
          cityName: '铁岭',
          cityCode: '2112'
        },
        {
          cityName: '朝阳',
          cityCode: '2113'
        },
        {
          cityName: '葫芦岛',
          cityCode: '2114'
        },
        {
          cityName: '沈抚改革创新示范区',
          cityCode: '2115'
        }
      ]
    },
    {
      value: '15',
      label: '内蒙古',
      code: 'N',
      scrollHeight: 0,
      city: [
        {
          cityName: '呼和浩特',
          cityCode: '1501'
        },
        {
          cityName: '包头',
          cityCode: '1502'
        },
        {
          cityName: '乌海',
          cityCode: '1503'
        },
        {
          cityName: '赤峰',
          cityCode: '1504'
        },
        {
          cityName: '通辽',
          cityCode: '1505'
        },
        {
          cityName: '鄂尔多斯',
          cityCode: '1506'
        },
        {
          cityName: '呼伦贝尔',
          cityCode: '1507'
        },
        {
          cityName: '巴彦淖尔',
          cityCode: '1508'
        },
        {
          cityName: '乌兰察布',
          cityCode: '1509'
        },
        {
          cityName: '兴安盟',
          cityCode: '1522'
        },
        {
          cityName: '锡林郭勒',
          cityCode: '1525'
        },
        {
          cityName: '阿拉善',
          cityCode: '1529'
        }
      ]
    },
    {
      value: '64',
      label: '宁夏',
      //"code": "N",
      scrollHeight: 0,
      city: [
        {
          cityName: '银川',
          cityCode: '6401'
        },
        {
          cityName: '石嘴山',
          cityCode: '6402'
        },
        {
          cityName: '吴忠',
          cityCode: '6403'
        },
        {
          cityName: '固原',
          cityCode: '6404'
        },
        {
          cityName: '中卫',
          cityCode: '6405'
        }
      ]
    },
    {
      value: '63',
      label: '青海',
      code: 'Q',
      scrollHeight: 0,
      city: [
        {
          cityName: '西宁',
          cityCode: '6301'
        },
        {
          cityName: '海东',
          cityCode: '6302'
        },
        {
          cityName: '海北藏族自治州',
          cityCode: '6322'
        },
        {
          cityName: '黄南藏族自治州',
          cityCode: '6323'
        },
        {
          cityName: '海南藏族自治州',
          cityCode: '6325'
        },
        {
          cityName: '果洛藏族自治州',
          cityCode: '6326'
        },
        {
          cityName: '玉树藏族自治州',
          cityCode: '6327'
        },
        {
          cityName: '海西蒙古族藏族自治州',
          cityCode: '6328'
        }
      ]
    },
    {
      value: '14',
      label: '山西',
      code: 'S',
      scrollHeight: 0,
      city: [
        {
          cityName: '太原',
          cityCode: '1401'
        },
        {
          cityName: '大同',
          cityCode: '1402'
        },
        {
          cityName: '阳泉',
          cityCode: '1403'
        },
        {
          cityName: '长治',
          cityCode: '1404'
        },
        {
          cityName: '晋城',
          cityCode: '1405'
        },
        {
          cityName: '朔州',
          cityCode: '1406'
        },
        {
          cityName: '晋中',
          cityCode: '1407'
        },
        {
          cityName: '运城',
          cityCode: '1408'
        },
        {
          cityName: '忻州',
          cityCode: '1409'
        },
        {
          cityName: '临汾',
          cityCode: '1410'
        },
        {
          cityName: '吕梁',
          cityCode: '1411'
        }
      ]
    },
    {
      value: '37',
      label: '山东',
      //"code": "S",
      scrollHeight: 0,
      city: [
        {
          cityName: '济南',
          cityCode: '3701'
        },
        {
          cityName: '青岛',
          cityCode: '3702'
        },
        {
          cityName: '淄博',
          cityCode: '3703'
        },
        {
          cityName: '枣庄',
          cityCode: '3704'
        },
        {
          cityName: '东营',
          cityCode: '3705'
        },
        {
          cityName: '烟台',
          cityCode: '3706'
        },
        {
          cityName: '潍坊',
          cityCode: '3707'
        },
        {
          cityName: '济宁',
          cityCode: '3708'
        },
        {
          cityName: '泰安',
          cityCode: '3709'
        },
        {
          cityName: '威海',
          cityCode: '3710'
        },
        {
          cityName: '日照',
          cityCode: '3711'
        },
        {
          cityName: '临沂',
          cityCode: '3713'
        },
        {
          cityName: '德州',
          cityCode: '3714'
        },
        {
          cityName: '聊城',
          cityCode: '3715'
        },
        {
          cityName: '滨州',
          cityCode: '3716'
        },
        {
          cityName: '菏泽',
          cityCode: '3717'
        }
      ]
    },
    {
      value: '51',
      label: '四川',
      //"code": "S",
      scrollHeight: 0,
      city: [
        {
          cityName: '成都',
          cityCode: '5101'
        },
        {
          cityName: '自贡',
          cityCode: '5103'
        },
        {
          cityName: '攀枝花',
          cityCode: '5104'
        },
        {
          cityName: '泸州',
          cityCode: '5105'
        },
        {
          cityName: '德阳',
          cityCode: '5106'
        },
        {
          cityName: '绵阳',
          cityCode: '5107'
        },
        {
          cityName: '广元',
          cityCode: '5108'
        },
        {
          cityName: '遂宁',
          cityCode: '5109'
        },
        {
          cityName: '内江',
          cityCode: '5110'
        },
        {
          cityName: '乐山',
          cityCode: '5111'
        },
        {
          cityName: '南充',
          cityCode: '5113'
        },
        {
          cityName: '眉山',
          cityCode: '5114'
        },
        {
          cityName: '宜宾',
          cityCode: '5115'
        },
        {
          cityName: '广安',
          cityCode: '5116'
        },
        {
          cityName: '达州',
          cityCode: '5117'
        },
        {
          cityName: '雅安',
          cityCode: '5118'
        },
        {
          cityName: '巴中',
          cityCode: '5119'
        },
        {
          cityName: '资阳',
          cityCode: '5120'
        },
        {
          cityName: '阿坝藏族羌族自治州',
          cityCode: '5132'
        },
        {
          cityName: '甘孜藏族自治州',
          cityCode: '5133'
        },
        {
          cityName: '凉山彝族自治州',
          cityCode: '5134'
        }
      ]
    },
    {
      value: '61',
      label: '陕西',
      //"code": "S",
      scrollHeight: 0,
      city: [
        {
          cityName: '西安',
          cityCode: '6101'
        },
        {
          cityName: '铜川',
          cityCode: '6102'
        },
        {
          cityName: '宝鸡',
          cityCode: '6103'
        },
        {
          cityName: '咸阳',
          cityCode: '6104'
        },
        {
          cityName: '渭南',
          cityCode: '6105'
        },
        {
          cityName: '延安',
          cityCode: '6106'
        },
        {
          cityName: '汉中',
          cityCode: '6107'
        },
        {
          cityName: '榆林',
          cityCode: '6108'
        },
        {
          cityName: '安康',
          cityCode: '6109'
        },
        {
          cityName: '商洛',
          cityCode: '6110'
        },
        {
          cityName: '西咸新区',
          cityCode: '6111'
        }
      ]
    },
    {
      value: '54',
      label: '西藏',
      code: 'X',
      scrollHeight: 0,
      city: [
        {
          cityName: '拉萨',
          cityCode: '5401'
        },
        {
          cityName: '日喀则',
          cityCode: '5402'
        },
        {
          cityName: '昌都',
          cityCode: '5403'
        },
        {
          cityName: '林芝',
          cityCode: '5404'
        },
        {
          cityName: '山南',
          cityCode: '5405'
        },
        {
          cityName: '那曲',
          cityCode: '5406'
        },
        {
          cityName: '阿里',
          cityCode: '5425'
        }
      ]
    },
    {
      value: '65',
      label: '新疆',
      //"code": "X",
      scrollHeight: 0,
      city: [
        {
          cityName: '乌鲁木齐',
          cityCode: '6501'
        },
        {
          cityName: '克拉玛依',
          cityCode: '6502'
        },
        {
          cityName: '吐鲁番',
          cityCode: '6504'
        },
        {
          cityName: '哈密',
          cityCode: '6505'
        },
        {
          cityName: '昌吉回族自治州',
          cityCode: '6523'
        },
        {
          cityName: '博尔塔拉蒙古自治州',
          cityCode: '6527'
        },
        {
          cityName: '巴音郭楞蒙古自治州',
          cityCode: '6528'
        },
        {
          cityName: '阿克苏',
          cityCode: '6529'
        },
        {
          cityName: '克孜勒苏柯尔克孜自治州',
          cityCode: '6530'
        },
        {
          cityName: '喀什',
          cityCode: '6531'
        },
        {
          cityName: '和田',
          cityCode: '6532'
        },
        {
          cityName: '伊犁哈萨克自治州',
          cityCode: '6540'
        },
        {
          cityName: '塔城',
          cityCode: '6542'
        },
        {
          cityName: '阿勒泰',
          cityCode: '6543'
        },
        {
          cityName: '石河子',
          cityCode: '659001'
        },
        {
          cityName: '阿拉尔',
          cityCode: '659002'
        },
        {
          cityName: '图木舒克',
          cityCode: '659003'
        },
        {
          cityName: '五家渠',
          cityCode: '659004'
        },
        {
          cityName: '北屯',
          cityCode: '659005'
        },
        {
          cityName: '铁门关',
          cityCode: '659006'
        },
        {
          cityName: '双河',
          cityCode: '659007'
        },
        {
          cityName: '可克达拉',
          cityCode: '659008'
        },
        {
          cityName: '昆玉',
          cityCode: '659009'
        },
        {
          cityName: '胡杨河',
          cityCode: '659010'
        },
        {
          cityName: '新星',
          cityCode: '659011'
        },
        {
          cityName: '白杨市',
          cityCode: '659012'
        }
      ]
    },
    {
      value: '53',
      label: '云南',
      code: 'Y',
      scrollHeight: 0,
      city: [
        {
          cityName: '昆明',
          cityCode: '5301'
        },
        {
          cityName: '曲靖',
          cityCode: '5303'
        },
        {
          cityName: '玉溪',
          cityCode: '5304'
        },
        {
          cityName: '保山',
          cityCode: '5305'
        },
        {
          cityName: '昭通',
          cityCode: '5306'
        },
        {
          cityName: '丽江',
          cityCode: '5307'
        },
        {
          cityName: '普洱',
          cityCode: '5308'
        },
        {
          cityName: '临沧',
          cityCode: '5309'
        },
        {
          cityName: '楚雄彝族自治州',
          cityCode: '5323'
        },
        {
          cityName: '红河哈尼族彝族自治州',
          cityCode: '5325'
        },
        {
          cityName: '文山壮族苗族自治州',
          cityCode: '5326'
        },
        {
          cityName: '西双版纳傣族自治州',
          cityCode: '5328'
        },
        {
          cityName: '大理白族自治州',
          cityCode: '5329'
        },
        {
          cityName: '德宏傣族景颇族自治州',
          cityCode: '5331'
        },
        {
          cityName: '怒江傈僳族自治州',
          cityCode: '5333'
        },
        {
          cityName: '迪庆藏族自治州',
          cityCode: '5334'
        }
      ]
    },
    {
      value: '33',
      label: '浙江',
      code: 'Z',
      scrollHeight: 0,
      city: [
        {
          cityName: '杭州',
          cityCode: '3301'
        },
        {
          cityName: '宁波',
          cityCode: '3302'
        },
        {
          cityName: '温州',
          cityCode: '3303'
        },
        {
          cityName: '嘉兴',
          cityCode: '3304'
        },
        {
          cityName: '湖州',
          cityCode: '3305'
        },
        {
          cityName: '绍兴',
          cityCode: '3306'
        },
        {
          cityName: '金华',
          cityCode: '3307'
        },
        {
          cityName: '衢州',
          cityCode: '3308'
        },
        {
          cityName: '舟山',
          cityCode: '3309'
        },
        {
          cityName: '台州',
          cityCode: '3310'
        },
        {
          cityName: '丽水',
          cityCode: '3311'
        }
      ]
    }
  ]
};

export const locationNumber = {
  '11': 1,
  '12': 1,
  '31': 1,
  '50': 1,
  '13': 11,
  '14': 11,
  '15': 12,
  '21': 14,
  '22': 9,
  '23': 13,
  '32': 13,
  '33': 11,
  '34': 16,
  '35': 9,
  '36': 11,
  '37': 17,
  '41': 17,
  '42': 13,
  '43': 14,
  '44': 21,
  '45': 14,
  '46': 4,
  '51': 21,
  '52': 9,
  '53': 16,
  '54': 7,
  '61': 10,
  '62': 14,
  '63': 8,
  '64': 5,
  '65': 14
};

export const industryOptions = [
  {
    value: 'A',
    count: 0,
    label: '农、林、牧、渔业'
  },

  {
    value: 'B',
    count: 0,
    label: '采矿业'
  },

  {
    value: 'C',
    count: 0,
    label: '制造业'
  },

  {
    value: 'D',
    count: 0,
    label: '电力、热力、燃气及水生产和供应业'
  },

  {
    value: 'E',
    count: 0,
    label: '建筑业'
  },

  {
    value: 'F',
    count: 0,
    label: '批发和零售业'
  },

  {
    value: 'G',
    count: 0,
    label: '交通运输、仓储和邮政业'
  },

  {
    value: 'H',
    count: 0,
    label: '住宿和餐饮业'
  },

  {
    value: 'I',
    count: 0,
    label: '信息传输、软件和信息技术服务业'
  },

  {
    value: 'J',
    count: 0,
    label: '金融业'
  },

  {
    value: 'K',
    count: 0,
    label: '房地产业'
  },

  {
    value: 'L',
    count: 0,
    label: '租赁和商务服务业'
  },

  {
    value: 'M',
    count: 0,
    label: '科学研究和技术服务业'
  },

  {
    value: 'N',
    count: 0,
    label: '水利、环境和公共设施管理业'
  },

  {
    value: 'O',
    count: 0,
    label: '居民服务、修理和其他服务业'
  },

  {
    value: 'P',
    count: 0,
    label: '教育'
  },

  {
    value: 'Q',
    count: 0,
    label: '卫生和社会工作'
  },

  {
    value: 'R',
    count: 0,
    label: '文化、体育和娱乐业'
  },

  {
    value: 'S',
    count: 0,
    label: '公共管理、社会保障和社会组织'
  },

  {
    value: 'T',
    count: 0,
    label: '国际组织'
  }
];

export const capitalOptions = [
  {
    label: '全部',
    value: '0'
  },
  {
    label: '20万以下',
    value: '1'
  },
  {
    label: '20~50万',
    value: '2'
  },
  {
    label: '50~100万',
    value: '3'
  },
  {
    label: '100~200万',
    value: '4'
  },
  {
    label: '200~500万',
    value: '5'
  },
  {
    label: '500万以上',
    value: '6'
  }
];

export const createDateOptions = [
  {
    label: '全部',
    value: '0'
  },
  {
    label: '1年以内',
    value: '1'
  },
  {
    label: '1-5年',
    value: '2'
  },
  {
    label: '5-10年',
    value: '3'
  },
  {
    label: '10-15年',
    value: '4'
  },
  {
    label: '15年以上',
    value: '5'
  }
];

export const locationMap = {
  '11': '北京',
  '12': '天津',
  '13': '河北',
  '14': '山西',
  '15': '内蒙古',
  '21': '辽宁',
  '22': '吉林',
  '23': '黑龙江',
  '31': '上海',
  '32': '江苏',
  '33': '浙江',
  '34': '安徽',
  '35': '福建',
  '36': '江西',
  '37': '山东',
  '41': '河南',
  '42': '湖北',
  '43': '湖南',
  '44': '广东',
  '45': '广西',
  '46': '海南',
  '50': '重庆',
  '51': '四川',
  '52': '贵州',
  '53': '云南',
  '54': '西藏',
  '61': '陕西',
  '62': '甘肃',
  '63': '青海',
  '64': '宁夏',
  '65': '新疆',
  '1301': '石家庄市',
  '1302': '唐山市',
  '1303': '秦皇岛市',
  '1304': '邯郸市',
  '1305': '邢台市',
  '1306': '保定市',
  '1307': '张家口市',
  '1308': '承德市',
  '1309': '沧州市',
  '1310': '廊坊市',
  '1311': '衡水市',
  '1401': '太原市',
  '1402': '大同市',
  '1403': '阳泉市',
  '1404': '长治市',
  '1405': '晋城市',
  '1406': '朔州市',
  '1407': '晋中市',
  '1408': '运城市',
  '1409': '忻州市',
  '1410': '临汾市',
  '1411': '吕梁市',
  '1501': '呼和浩特市',
  '1502': '包头市',
  '1503': '乌海市',
  '1504': '赤峰市',
  '1505': '通辽市',
  '1506': '鄂尔多斯市',
  '1507': '呼伦贝尔市',
  '1508': '巴彦淖尔盟',
  '1509': '乌兰察布盟',
  '1522': '兴安盟',
  '1525': '锡林郭勒盟',
  '1529': '阿拉善盟',
  '2101': '沈阳市',
  '2102': '大连市',
  '2103': '鞍山市',
  '2104': '抚顺市',
  '2105': '本溪市',
  '2106': '丹东市',
  '2107': '锦州市',
  '2108': '营口市',
  '2109': '阜新市',
  '2110': '辽阳市',
  '2111': '盘锦市',
  '2112': '铁岭市',
  '2113': '朝阳市',
  '2114': '葫芦岛市',
  '2201': '长春市',
  '2202': '吉林市',
  '2203': '四平市',
  '2204': '辽源市',
  '2205': '通化市',
  '2206': '白山市',
  '2207': '松原市',
  '2208': '白城市',
  '2224': '延边朝鲜族自治州',
  '2301': '哈尔滨市',
  '2302': '齐齐哈尔市',
  '2303': '鸡西市',
  '2304': '鹤岗市',
  '2305': '双鸭山市',
  '2306': '大庆市',
  '2307': '伊春市',
  '2308': '佳木斯市',
  '2309': '七台河市',
  '2310': '牡丹江市',
  '2311': '黑河市',
  '2312': '绥化市',
  '2327': '大兴安岭地区',
  '3201': '南京市',
  '3202': '无锡市',
  '3203': '徐州市',
  '3204': '常州市',
  '3205': '苏州市',
  '3206': '南通市',
  '3207': '连云港市',
  '3208': '淮安市',
  '3209': '盐城市',
  '3210': '扬州市',
  '3211': '镇江市',
  '3212': '泰州市',
  '3213': '宿迁市',
  '3301': '杭州市',
  '3302': '宁波市',
  '3303': '温州市',
  '3304': '嘉兴市',
  '3305': '湖州市',
  '3306': '绍兴市',
  '3307': '金华市',
  '3308': '衢州市',
  '3309': '舟山市',
  '3310': '台州市',
  '3311': '丽水市',
  '3401': '合肥市',
  '3402': '芜湖市',
  '3403': '蚌埠市',
  '3404': '淮南市',
  '3405': '马鞍山市',
  '3406': '淮北市',
  '3407': '铜陵市',
  '3408': '安庆市',
  '3410': '黄山市',
  '3411': '滁州市',
  '3412': '阜阳市',
  '3413': '宿州市',
  '3415': '六安市',
  '3416': '亳州市',
  '3417': '池州市',
  '3418': '宣城市',
  '3501': '福州市',
  '3502': '厦门市',
  '3503': '莆田市',
  '3504': '三明市',
  '3505': '泉州市',
  '3506': '漳州市',
  '3507': '南平市',
  '3508': '龙岩市',
  '3509': '宁德市',
  '3601': '南昌市',
  '3602': '景德镇市',
  '3603': '萍乡市',
  '3604': '九江市',
  '3605': '新余市',
  '3606': '鹰潭市',
  '3607': '赣州市',
  '3608': '吉安市',
  '3609': '宜春市',
  '3610': '抚州市',
  '3611': '上饶市',
  '3701': '济南市',
  '3702': '青岛市',
  '3703': '淄博市',
  '3704': '枣庄市',
  '3705': '东营市',
  '3706': '烟台市',
  '3707': '潍坊市',
  '3708': '济宁市',
  '3709': '泰安市',
  '3710': '威海市',
  '3711': '日照市',
  '3712': '莱芜市',
  '3713': '临沂市',
  '3714': '德州市',
  '3715': '聊城市',
  '3716': '滨州市',
  '3717': '菏泽市',
  '4101': '郑州市',
  '4102': '开封市',
  '4103': '洛阳市',
  '4104': '平顶山市',
  '4105': '安阳市',
  '4106': '鹤壁市',
  '4107': '新乡市',
  '4108': '焦作市',
  '4109': '濮阳市',
  '4110': '许昌市',
  '4111': '漯河市',
  '4112': '三门峡市',
  '4113': '南阳市',
  '4114': '商丘市',
  '4115': '信阳市',
  '4116': '周口市',
  '4117': '驻马店市',
  '4201': '武汉市',
  '4202': '黄石市',
  '4203': '十堰市',
  '4205': '宜昌市',
  '4206': '襄阳市',
  '4207': '鄂州市',
  '4208': '荆门市',
  '4209': '孝感市',
  '4210': '荆州市',
  '4211': '黄冈市',
  '4212': '咸宁市',
  '4213': '随州市',
  '4228': '恩施土家族苗族自治州',
  '4301': '长沙市',
  '4302': '株洲市',
  '4303': '湘潭市',
  '4304': '衡阳市',
  '4305': '邵阳市',
  '4306': '岳阳市',
  '4307': '常德市',
  '4308': '张家界市',
  '4309': '益阳市',
  '4310': '郴州市',
  '4311': '永州市',
  '4312': '怀化市',
  '4313': '娄底地区',
  '4331': '湘西土家族苗族自治州',
  '4401': '广州市',
  '4402': '韶关市',
  '4403': '深圳市',
  '4404': '珠海市',
  '4405': '汕头市',
  '4406': '佛山市',
  '4407': '江门市',
  '4408': '湛江市',
  '4409': '茂名市',
  '4412': '肇庆市',
  '4413': '惠州市',
  '4414': '梅州市',
  '4415': '汕尾市',
  '4416': '河源市',
  '4417': '阳江市',
  '4418': '清远市',
  '4419': '东莞市',
  '4420': '中山市',
  '4451': '潮州市',
  '4452': '揭阳市',
  '4453': '云浮市',
  '4501': '南宁市',
  '4502': '柳州市',
  '4503': '桂林市',
  '4504': '梧州市',
  '4505': '北海市',
  '4506': '防城港市',
  '4507': '钦州市',
  '4508': '贵港市',
  '4509': '玉林市',
  '4510': '百色市',
  '4511': '贺州市',
  '4512': '河池市',
  '4513': '来宾市',
  '4514': '崇左市',
  '4601': '海口市',
  '4602': '三亚市',
  '4603': '三沙市',
  '4604': '儋州市',
  '5101': '成都市',
  '5103': '自贡市',
  '5104': '攀枝花市',
  '5105': '泸州市',
  '5106': '德阳市',
  '5107': '绵阳市',
  '5108': '广元市',
  '5109': '遂宁市',
  '5110': '内江市',
  '5111': '乐山市',
  '5113': '南充市',
  '5114': '眉山市',
  '5115': '宜宾市',
  '5116': '广安市',
  '5117': '达州市',
  '5118': '雅安市',
  '5119': '巴中市',
  '5120': '资阳市',
  '5132': '阿坝藏族羌族自治州',
  '5133': '甘孜藏族自治州',
  '5134': '凉山彝族自治州',
  '5201': '贵阳市',
  '5202': '六盘水市',
  '5203': '遵义市',
  '5204': '安顺市',
  '5205': '毕节市',
  '5206': '铜仁市',
  '5223': '黔西南布依族苗族自治州',
  '5226': '黔东南苗族侗族自治州',
  '5227': '黔南布依族苗族自治州',
  '5301': '昆明市',
  '5303': '曲靖市',
  '5304': '玉溪市',
  '5305': '保山市',
  '5306': '昭通市',
  '5307': '丽江市',
  '5308': '普洱市',
  '5309': '临沧市',
  '5323': '楚雄彝族自治州',
  '5325': '红河哈尼族彝族自治州',
  '5326': '文山壮族苗族自治州',
  '5328': '西双版纳傣族自治州',
  '5329': '大理白族自治州',
  '5331': '德宏傣族景颇族自治州',
  '5333': '怒江傈僳族自治州',
  '5334': '迪庆藏族自治州',
  '5401': '拉萨市',
  '5402': '日喀则地区',
  '5403': '昌都地区',
  '5404': '林芝地区',
  '5405': '山南地区',
  '5424': '那曲地区',
  '5425': '阿里地区',
  '6101': '西安市',
  '6102': '铜川市',
  '6103': '宝鸡市',
  '6104': '咸阳市',
  '6105': '渭南市',
  '6106': '延安市',
  '6107': '汉中市',
  '6108': '榆林市',
  '6109': '安康市',
  '6110': '商洛市',
  '6111': '西咸新区',
  '6201': '兰州市',
  '6202': '嘉峪关市',
  '6203': '金昌市',
  '6204': '白银市',
  '6205': '天水市',
  '6206': '武威市',
  '6207': '张掖市',
  '6208': '平凉市',
  '6209': '酒泉市',
  '6210': '庆阳市',
  '6211': '定西市',
  '6212': '陇南市',
  '6229': '临夏回族自治州',
  '6230': '甘南藏族自治州',
  '6301': '西宁市',
  '6302': '海东地区',
  '6322': '海北藏族自治州',
  '6323': '黄南藏族自治州',
  '6325': '海南藏族自治州',
  '6326': '果洛藏族自治州',
  '6327': '玉树藏族自治州',
  '6328': '海西蒙古族藏族自治州',
  '6401': '银川市',
  '6402': '石嘴山市',
  '6403': '吴忠市',
  '6404': '固原市',
  '6405': '中卫市',
  '6501': '乌鲁木齐市',
  '6502': '克拉玛依市',
  '6504': '吐鲁番地区',
  '6505': '哈密地区',
  '6523': '昌吉回族自治州',
  '6527': '博尔塔拉蒙古自治州',
  '6528': '巴音郭楞蒙古自治州',
  '6529': '阿克苏地区',
  '6530': '克孜勒苏柯尔克孜自治州',
  '6531': '喀什地区',
  '6532': '和田地区',
  '6540': '伊犁哈萨克自治州',
  '6542': '塔城地区',
  '6543': '阿勒泰地区',
  '419001': '济源市',
  '429004': '仙桃市',
  '429005': '潜江市',
  '429006': '天门市',
  '429021': '神农架林区',
  '469001': '五指山市',
  '469002': '琼海市',
  '469005': '文昌市',
  '469006': '万宁市',
  '469007': '东方市',
  '469021': '定安县',
  '469022': '屯昌县',
  '469023': '澄迈县',
  '469024': '临高县',
  '469025': '白沙黎族自治县',
  '469026': '昌江黎族自治县',
  '469027': '乐东黎族自治县',
  '469028': '陵水黎族自治县',
  '469029': '保亭黎族苗族自治县',
  '469030': '琼中黎族苗族自治县',
  '659001': '石河子市',
  '659002': '阿拉尔市',
  '659003': '图木舒克市',
  '659004': '五家渠市',
  '659005': '北屯市',
  '659006': '铁门关市',
  '659007': '双河市',
  '659008': '可克达拉市',
  '659009': '昆玉市',
  '5209': '贵安新区',
  '1331': '雄安新区',
  '2115': '沈抚改革创新示范区',
  '659012': '白杨市'
};

export const placeholderList = {
  companyname: '请输入企业名称',
  products: '请输入产品、APP名称',
  businessscope: '请输入主营业务或经营范围关键词',
  jobtitle: '请输入招聘职位（支持搜索最近6个月内的招聘职位）',
  semkeyword: '请输入网络推广关键词或产品名称',
  guanwang: '请输入网站名称',
  shangbiao: '请输入商标名称',
  zhuanli: '请输入专利名称或说明',
  auction: '请输入招标投标项目名称或公告名称',
  address: '输入地址或地区，将为您推荐附近的企业',
  trademarkName: '请输入商标名称',
  patentName: '请输入专利名称',
  certL2Name: '请输入证书名称'
};
export const tipContentList = {
  search1: '没有目标关键词？可以试试不同过滤条件组合来得到搜索结果。',
  search2:
    '指定1个搜索范围后，将根据您提供的关键词进行专项搜索。若希望扩大搜索范围，可以尝试默认的智能搜索。',
  createSea1:
    '可由主账户创建若干，容量2000条，已被企业内用户转为线索或删除的数据创建时将会自动剔除，默认对企业内全部用户公开。',
  createSea2:
    '每个用户可创建1个，容量1200条。我的公海仅自己可见，已被企业内用户转线索或删除的数据创建时将会自动剔除。',
  createSea3:
    '可由主账户创建3个，容量2000条，已被企业内用户转为线索或删除的数据创建时将会自动剔除，默认对企业内全部用户公开。',
  replaceSea1:
    '当前类型的公海数量达到上限，将无法直接创建新的公海。用户可以通过替换公海快速删除老公海，同时创建新公海。',
  sea1:
    '将常用的搜索结果保存为公海，后期在公海中挑选线索，省去了每次搜索组合搜索条件的麻烦。',
  sea2: '当前公海线索消耗（添加或删除）大于100条时，可以更新补充数据。',
  sea3:
    '可由主账户创建若干，容量2000条，已被企业内用户转为线索或删除的数据创建时将会自动剔除，默认对企业内全部用户公开。',
  sea4:
    '每个用户可创建1个，容量1200条。我的公海仅自己可见，已被企业内用户转线索或删除的数据创建时将会自动剔除。',
  sea5:
    '可由主账户创建3个，容量2000条，已被企业内用户转为线索或删除的数据创建时将会自动剔除，默认对企业内全部用户公开。'
};

export const mapChinese = {
  LaGouCompany: '拉勾网',
  DajieCompany: '大街网',
  YingcaiZhaopin: '英才网',
  SogouCompany: '搜狗',
  Hunt007Company: 'hunt007',
  ZhiYouJiCompany: '职友集',
  SanLiuRenCaiWang: '36人才网',
  KanzhunCompany: '看准网',
  GanJiWangCompany: '赶集网',
  '58Company': '58同城',
  BaiduZhaopinCompany: '百度招聘',
  JunCaiZhaopinCompany: '俊才招聘',
  ZhiLianZhaopingCompany: '智联招聘',
  '51JobCompany': '51Job',
  BaiDaCompany: '百大英才网',
  BossZhiPinKeyword: 'BOSS直聘',
  BLZPCompany: '伯乐招聘'
};
export const industryMap = {
  A: '农、林、牧、渔业',
  B: '采矿业',
  C: '制造业',
  D: '电力、热力、燃气及水生产和供应业',
  E: '建筑业',
  F: '批发和零售业',
  G: '交通运输、仓储和邮政业',
  H: '住宿和餐饮业',
  I: '信息传输、软件和信息技术服务业',
  J: '金融业',
  K: '房地产业',
  L: '租赁和商务服务业',
  M: '科学研究和技术服务业',
  N: '水利、环境和公共设施管理业',
  O: '居民服务、修理和其他服务业',
  P: '教育',
  Q: '卫生和社会工作',
  R: '文化、体育和娱乐业',
  S: '公共管理、社会保障和社会组织',
  T: '国际组织'
};

export const capitalMap = {
  // '0': '全部',
  '1': '20万以下',
  '2': '20~50万',
  '3': '50~100万',
  '4': '100~200万',
  '5': '200~500万',
  '6': '500万以上'
};

export const capitalDict = [
  { key: '1', value: '20万以下' },
  { key: '2', value: '20~50万' },
  { key: '3', value: '50~100万' },
  { key: '4', value: '100~200万' },
  { key: '5', value: '200~500万' },
  { key: '6', value: '500万以上' }
];

export const createDateMap = {
  // '0': '全部',
  '1': '1年以内',
  '2': '1-5年',
  '3': '5-10年',
  '4': '10-15年',
  '5': '15年以上'
};
export const b2bMap = {
  // bussinessProduct: '主营产品或服务',
  annualTurnover: '年营业额', //15
  companyType: '企业类型', //5
  industry: '主营行业', //6
  bussinessModel: '经营模式', //7
  businessAddress: '经营地址', //8
  scale: '员工人数', //9
  brand: '经营品牌', //10
  businessClient: '主要客户群', //11
  businessMarket: '主要场', //12
  annualExpVolume: '年出口额', //13
  annualImpVolume: '年进口额', //14
  registerBank: '开户银行', //16
  bankAccount: '银行账号', //17
  OEMService: '是否提供OEM服务', //18
  researchRecruitNum: '研发部门人数', //19
  monthYield: '月产量', //20
  factoryArea: '厂房面积', //21
  qualityControl: '质量控制', //22
  city: '所属城市', //4
  mgtCert: '管理体系认证', //23
  certificate: '证书及荣誉', //24
  website: '公司主页' //25
  // establishedDate: '创建时间',
  // invType: '法定代表人',
  // registerCapital: '注册资本',
  // registerAddress: '注册地址',
  // isWild: '是否在工商注册',
  // memberEvaluation: '会员评价',
  // creditPerson: '资信参考人',
  // shareholderNum: '股东人数',
  // certInfo: '认证信息',
  // licenseInstitution: '发证机关',
  // popularValue: '人气值',
  // webOpenDate: '网站开通时间'
};
export const semMap = {
  BaiduCompany: '百度SEM',
  SogouCompany: '搜狗SEM',
  '360Company': '360SEM',
  BiyingCompany: '必应SEM'
};
export const trademarkMap = {
  '1': '1 - 化学原料',
  '2': '2 - 颜料油漆',
  '3': '3 - 日化用品',
  '4': '4 - 燃料油脂',
  '5': '5 - 医药营养',
  '6': '6 - 金属材料',
  '7': '7 - 机械设备',
  '8': '8 - 手动器械',
  '9': '9 - 科学电子',
  '10': '10 - 医疗器械',
  '11': '11 - 电器设备',
  '12': '12 - 运载工具',
  '13': '13 - 军火烟花',
  '14': '14 - 珠宝钟表',
  '15': '15 - 乐器用品',
  '16': '16 - 文化办公',
  '17': '17 - 橡胶制品',
  '18': '18 - 皮革皮具',
  '19': '19 - 建筑材料',
  '20': '20 - 家具附件',
  '21': '21 - 厨房日用',
  '22': '22 - 绳网袋篷',
  '23': '23 - 纺织纱线',
  '24': '24 - 纺织布料',
  '25': '25 - 服装鞋袜',
  '26': '26 - 纽扣拉链',
  '27': '27 - 地毯墙纸',
  '28': '28 - 体育器材',
  '29': '29 - 食品罐头',
  '30': '30 - 面糕茶糖',
  '31': '31 - 水果花木',
  '32': '32 - 啤酒饮料',
  '33': '33 - 酒精饮品',
  '34': '34 - 烟草烟具',
  '35': '35 - 广告销售',
  '36': '36 - 金融物管',
  '37': '37 - 建筑修理',
  '38': '38 - 通讯电信',
  '39': '39 - 运输贮藏',
  '40': '40 - 材料加工',
  '41': '41 - 教育娱乐',
  '42': '42 - 技术服务',
  '43': '43 - 餐饮酒店',
  '44': '44 - 医疗园艺',
  '45': '45 - 社会法律'
};
export const scopeMap = {
  companyname: '企业名称',
  products: '产品',
  businessscope: '经营范围',
  jobtitle: '招聘职位',
  semkeyword: '网络推广',
  guanwang: '网站名称',
  shangbiao: '商标',
  zhuanli: '专利',
  auction: '招标投标',
  address: '地址',
  patentName: '专利',
  trademarkName: '商标',
  certL2Name: '证书'
};

export const entstatusMap = {
  '1': '在营/存续',
  '4': '迁入/迁出',
  '2': '吊销/撤销',
  '3': '注销',
  '8': '停业',
  '9': '其他'
};
export const top = {
  '1': '民营',
  '2': '国有企业',
  '3': '外资、中外合资',
  '4': '港、澳、台投资',
  '5': '个体工商户',
  '6': '其他企业'
};
export const enttypeList = [
  { value: '0', label: '全部' },
  { value: '1', label: '民营' },
  { value: '2', label: '国有企业' },
  { value: '3', label: '外资、中外合资' },
  { value: '4', label: '港、澳、台投资' },
  { value: '5', label: '个体工商户' },
  { value: '6', label: '其他企业' }
];

export const entStatusList = [
  { value: '0', label: '全部' },
  { value: '1', label: '在业' },
  { value: '4', label: '迁出' },
  { value: '2', label: '吊销/撤销' },
  { value: '3', label: '注销' },
  { value: '8', label: '停业' },
  { value: '9', label: '其他' }
];
export const operationMap = {
  '1': 'export',
  '2': 'delete',
  '3': 'add',
  '4': 'createSea',
  '5': 'updateSea',
  '6': 'createSea',
  '7': 'updateSea',
  '8': 'task',
  '9': 'download',
  '10': 'robot',
  '11': 'sync',
  '12': 'recover',
  '13': 'diverting',
  '14': 'divert'
};
export const accountType = {
  root: 'Root',
  admin: 'Admin',
  agent: '分销',
  customer: '销售客服',
  bigcustomer: '大客户',
  manager: '管理员',
  mainaccount: '主账户',
  subaccount: '子账户',
  person: '个人账户'
};

export const exType1 = [
  { value: 1, label: '1年' },
  { value: 2, label: '2年' },
  { value: 3, label: '3年' }
];
export const exType2 = [
  { value: 12, label: '12个月' },
  { value: 24, label: '24个月' },
  { value: 36, label: '36个月' }
];

//topHandle底部到页面顶部高度
export const topHandleOffSetMap = {
  sea: 330,
  recycle: 261,
  selfTask: 286,
  childTask: 261,
  taskRobot: 261,
  pool: 261,
  callRecords: 261
};

//二级行业分类
export const industrySecondOptions = [
  {
    value: '1',
    label: '农业'
  },
  {
    value: '2',
    label: '林业'
  },
  {
    value: '3',
    label: '畜牧业'
  },
  {
    value: '4',
    label: '渔业'
  },
  {
    value: '5',
    label: '农、林、牧、渔专业及辅助性活动'
  },
  {
    value: '6',
    label: '煤炭开采和洗选业'
  },
  {
    value: '7',
    label: '石油和天然气开采业'
  },
  {
    value: '8',
    label: '黑色金属矿采选业'
  },
  {
    value: '9',
    label: '有色金属矿采选业'
  },
  {
    value: '10',
    label: '非金属矿采选业'
  },
  {
    value: '11',
    label: '开采专业及辅助性活动'
  },
  {
    value: '12',
    label: '其他采矿业'
  },
  {
    value: '13',
    label: '农副食品加工业'
  },
  {
    value: '14',
    label: '食品制造业'
  },
  {
    value: '16',
    label: '烟草制品业'
  },
  {
    value: '17',
    label: '纺织业'
  },
  {
    value: '18',
    label: '纺织服装、服饰业'
  },
  {
    value: '19',
    label: '皮革、毛皮、羽毛及其制品和制鞋业'
  },
  {
    value: '20',
    label: '木材加工和木、竹、藤、棕、草制品业'
  },
  {
    value: '21',
    label: '家具制造业'
  },
  {
    value: '22',
    label: '造纸和纸制品业'
  },
  {
    value: '23',
    label: '印刷和记录媒介复制业'
  },
  {
    value: '24',
    label: '文教、工美、体育和娱乐用品制造业'
  },
  {
    value: '25',
    label: '石油、煤炭及其他燃料加工业'
  },
  {
    value: '26',
    label: '化学原料和化学制品制造业'
  },
  {
    value: '27',
    label: '医药制造业'
  },
  {
    value: '28',
    label: '化学纤维制造业'
  },
  {
    value: '29',
    label: '橡胶和塑料制品业'
  },
  {
    value: '30',
    label: '非金属矿物制品业'
  },
  {
    value: '31',
    label: '黑色金属冶炼和压延加工业'
  },
  {
    value: '32',
    label: '有色金属冶炼和压延加工业'
  },
  {
    value: '33',
    label: '金属制品业'
  },
  {
    value: '34',
    label: '通用设备制造业'
  },
  {
    value: '35',
    label: '专用设备制造业'
  },
  {
    value: '36',
    label: '汽车制造业'
  },
  {
    value: '37',
    label: '铁路、船舶、航空航天和其他运输设备制造业'
  },
  {
    value: '38',
    label: '电气机械和器材制造业'
  },
  {
    value: '39',
    label: '计算机、通信和其他电子设备制造业'
  },
  {
    value: '40',
    label: '仪器仪表制造业'
  },
  {
    value: '41',
    label: '其他制造业'
  },
  {
    value: '42',
    label: '废弃资源综合利用业'
  },
  {
    value: '43',
    label: '金属制品、机械和设备修理业'
  },
  {
    value: '44',
    label: '电力、热力生产和供应业'
  },
  {
    value: '45',
    label: '燃气生产和供应业'
  },
  {
    value: '46',
    label: '水的生产和供应业'
  },
  {
    value: '47',
    label: '房屋建筑业'
  },
  {
    value: '48',
    label: '土木工程建筑业'
  },
  {
    value: '49',
    label: '建筑安装业'
  },
  {
    value: '50',
    label: '建筑装饰、装修和其他建筑业'
  },
  {
    value: '51',
    label: '批发业'
  },
  {
    value: '52',
    label: '零售业'
  },
  {
    value: '53',
    label: '铁路运输业'
  },
  {
    value: '54',
    label: '道路运输业'
  },
  {
    value: '55',
    label: '水上运输业'
  },
  {
    value: '56',
    label: '航空运输业'
  },
  {
    value: '57',
    label: '管道运输业'
  },
  {
    value: '58',
    label: '多式联运和运输代理业'
  },
  {
    value: '59',
    label: '装卸搬运和仓储业'
  },
  {
    value: '60',
    label: '邮政业'
  },
  {
    value: '61',
    label: '住宿业'
  },
  {
    value: '62',
    label: '餐饮业'
  },
  {
    value: '63',
    label: '电信、广播电视和卫星传输服务'
  },
  {
    value: '64',
    label: '互联网和相关服务'
  },
  {
    value: '65',
    label: '软件和信息技术服务业'
  },
  {
    value: '66',
    label: '货币金融服务'
  },
  {
    value: '67',
    label: '资本市场服务'
  },
  {
    value: '68',
    label: '保险业'
  },
  {
    value: '69',
    label: '其他金融业'
  },
  {
    value: '70',
    label: '房地产业'
  },
  {
    value: '71',
    label: '租赁业'
  },
  {
    value: '72',
    label: '商务服务业'
  },
  {
    value: '73',
    label: '研究和试验发展'
  },
  {
    value: '74',
    label: '专业技术服务业'
  },
  {
    value: '75',
    label: '科技推广和应用服务业'
  },
  {
    value: '76',
    label: '水利管理业'
  },
  {
    value: '77',
    label: '生态保护和环境治理业'
  },
  {
    value: '78',
    label: '公共设施管理业'
  },
  {
    value: '79',
    label: '土地管理业'
  },
  {
    value: '80',
    label: '居民服务业'
  },
  {
    value: '81',
    label: '机动车、电子产品和日用产品修理业'
  },
  {
    value: '82',
    label: '其他服务业'
  },
  {
    value: '83',
    label: '教育'
  },
  {
    value: '84',
    label: '卫生'
  },
  {
    value: '85',
    label: '社会工作'
  },
  {
    value: '86',
    label: '新闻和出版业'
  },
  {
    value: '87',
    label: '广播、电视、电影和录音制作业'
  },
  {
    value: '88',
    label: '文化艺术业'
  },
  {
    value: '89',
    label: '体育'
  },
  {
    value: '90',
    label: '娱乐业'
  },
  {
    value: '91',
    label: '中国共产党机关'
  },
  {
    value: '92',
    label: '国家机构'
  },
  {
    value: '93',
    label: '人民政协、民主党派'
  },
  {
    value: '94',
    label: '社会保障'
  },
  {
    value: '95',
    label: '群众团体、社会团体和其他成员组织'
  },
  {
    value: '96',
    label: '基层群众自治组织及其他组织'
  },
  {
    value: '97',
    label: '国际组织'
  }
];
export const industrySubMap = {
  '1': '农业',
  '2': '林业',
  '3': '畜牧业',
  '4': '渔业',
  '5': '农、林、牧、渔专业及辅助性活动',
  '6': '煤炭开采和洗选业',
  '7': '石油和天然气开采业',
  '8': '黑色金属矿采选业',
  '9': '有色金属矿采选业',
  '10': '非金属矿采选业',
  '11': '开采专业及辅助性活动',
  '12': '其他采矿业',
  '13': '农副食品加工业',
  '14': '食品制造业',
  '16': '烟草制品业',
  '17': '纺织业',
  '18': '纺织服装、服饰业',
  '19': '皮革、毛皮、羽毛及其制品和制鞋业',
  '20': '木材加工和木、竹、藤、棕、草制品业',
  '21': '家具制造业',
  '22': '造纸和纸制品业',
  '23': '印刷和记录媒介复制业',
  '24': '文教、工美、体育和娱乐用品制造业',
  '25': '石油、煤炭及其他燃料加工业',
  '26': '化学原料和化学制品制造业',
  '27': '医药制造业',
  '28': '化学纤维制造业',
  '29': '橡胶和塑料制品业',
  '30': '非金属矿物制品业',
  '31': '黑色金属冶炼和压延加工业',
  '32': '有色金属冶炼和压延加工业',
  '33': '金属制品业',
  '34': '通用设备制造业',
  '35': '专用设备制造业',
  '36': '汽车制造业',
  '37': '铁路、船舶、航空航天和其他运输设备制造业',
  '38': '电气机械和器材制造业',
  '39': '计算机、通信和其他电子设备制造业',
  '40': '仪器仪表制造业',
  '41': '其他制造业',
  '42': '废弃资源综合利用业',
  '43': '金属制品、机械和设备修理业',
  '44': '电力、热力生产和供应业',
  '45': '燃气生产和供应业',
  '46': '水的生产和供应业',
  '47': '房屋建筑业',
  '48': '土木工程建筑业',
  '49': '建筑安装业',
  '50': '建筑装饰、装修和其他建筑业',
  '51': '批发业',
  '52': '零售业',
  '53': '铁路运输业',
  '54': '道路运输业',
  '55': '水上运输业',
  '56': '航空运输业',
  '57': '管道运输业',
  '58': '多式联运和运输代理业',
  '59': '装卸搬运和仓储业',
  '60': '邮政业',
  '61': '住宿业',
  '62': '餐饮业',
  '63': '电信、广播电视和卫星传输服务',
  '64': '互联网和相关服务',
  '65': '软件和信息技术服务业',
  '66': '货币金融服务',
  '67': '资本市场服务',
  '68': '保险业',
  '69': '其他金融业',
  '70': '房地产业',
  '71': '租赁业',
  '72': '商务服务业',
  '73': '研究和试验发展',
  '74': '专业技术服务业',
  '75': '科技推广和应用服务业',
  '76': '水利管理业',
  '77': '生态保护和环境治理业',
  '78': '公共设施管理业',
  '79': '土地管理业',
  '80': '居民服务业',
  '81': '机动车、电子产品和日用产品修理业',
  '82': '其他服务业',
  '83': '教育',
  '84': '卫生',
  '85': '社会工作',
  '86': '新闻和出版业',
  '87': '广播、电视、电影和录音制作业',
  '88': '文化艺术业',
  '89': '体育',
  '90': '娱乐业',
  '91': '中国共产党机关',
  '92': '国家机构',
  '93': '人民政协、民主党派',
  '94': '社会保障',
  '95': '群众团体、社会团体和其他成员组织',
  '96': '基层群众自治组织及其他组织',
  '97': '国际组织'
};
export const industryMapMathResver = {
  '1': 'A',
  '2': 'B',
  '3': 'C',
  '4': 'D',
  '5': 'E',
  '6': 'F',
  '7': 'G',
  '8': 'H',
  '9': 'I',
  '10': 'J',
  '11': 'K',
  '12': 'L',
  '13': 'M',
  '14': 'N',
  '15': 'O',
  '16': 'P',
  '17': 'Q',
  '18': 'R',
  '19': 'S',
  '20': 'T'
};
export const industrySecondClassify = [
  {
    value: '1',
    label: '农、林、牧、渔业',
    code: 'A',
    count: 0,
    industry: [
      {
        industryCode: '1',
        industryName: '农业'
      },
      {
        industryCode: '2',
        industryName: '林业'
      },
      {
        industryCode: '3',
        industryName: '畜牧业'
      },
      {
        industryCode: '4',
        industryName: '渔业'
      },
      {
        industryCode: '5',
        industryName: '农、林、牧、渔专业及辅助性活动'
      }
    ]
  },
  {
    value: '2',
    label: '采矿业',
    code: 'B',
    count: 0,
    industry: [
      {
        industryCode: '6',
        industryName: '煤炭开采和洗选业'
      },
      {
        industryCode: '7',
        industryName: '石油和天然气开采业'
      },
      {
        industryCode: '8',
        industryName: '黑色金属矿采选业'
      },
      {
        industryCode: '9',
        industryName: '有色金属矿采选业'
      },
      {
        industryCode: '10',
        industryName: '非金属矿采选业'
      },
      {
        industryCode: '11',
        industryName: '开采专业及辅助性活动'
      },
      {
        industryCode: '12',
        industryName: '其他采矿业'
      }
    ]
  },
  {
    value: '3',
    label: '制造业',
    code: 'C',
    count: 0,
    industry: [
      {
        industryCode: '13',
        industryName: '农副食品加工业'
      },
      {
        industryCode: '14',
        industryName: '食品制造业'
      },
      {
        industryCode: '16',
        industryName: '烟草制品业'
      },
      {
        industryCode: '17',
        industryName: '纺织业'
      },
      {
        industryCode: '18',
        industryName: '纺织服装、服饰业'
      },
      {
        industryCode: '19',
        industryName: '皮革、毛皮、羽毛及其制品和制鞋业'
      },
      {
        industryCode: '20',
        industryName: '木材加工和木、竹、藤、棕、草制品业'
      },
      {
        industryCode: '21',
        industryName: '家具制造业'
      },
      {
        industryCode: '22',
        industryName: '造纸和纸制品业'
      },
      {
        industryCode: '23',
        industryName: '印刷和记录媒介复制业'
      },
      {
        industryCode: '24',
        industryName: '文教、工美、体育和娱乐用品制造业'
      },
      {
        industryCode: '25',
        industryName: '石油、煤炭及其他燃料加工业'
      },
      {
        industryCode: '26',
        industryName: '化学原料和化学制品制造业'
      },
      {
        industryCode: '27',
        industryName: '医药制造业'
      },
      {
        industryCode: '28',
        industryName: '化学纤维制造业'
      },
      {
        industryCode: '29',
        industryName: '橡胶和塑料制品业'
      },
      {
        industryCode: '30',
        industryName: '非金属矿物制品业'
      },
      {
        industryCode: '31',
        industryName: '黑色金属冶炼和压延加工业'
      },
      {
        industryCode: '32',
        industryName: '有色金属冶炼和压延加工业'
      },
      {
        industryCode: '33',
        industryName: '金属制品业'
      },
      {
        industryCode: '34',
        industryName: '通用设备制造业'
      },
      {
        industryCode: '35',
        industryName: '专用设备制造业'
      },
      {
        industryCode: '36',
        industryName: '汽车制造业'
      },
      {
        industryCode: '37',
        industryName: '铁路、船舶、航空航天和其他运输设备制造业'
      },
      {
        industryCode: '38',
        industryName: '电气机械和器材制造业'
      },
      {
        industryCode: '39',
        industryName: '计算机、通信和其他电子设备制造业'
      },
      {
        industryCode: '40',
        industryName: '仪器仪表制造业'
      },
      {
        industryCode: '41',
        industryName: '其他制造业'
      },
      {
        industryCode: '42',
        industryName: '废弃资源综合利用业'
      },
      {
        industryCode: '43',
        industryName: '金属制品、机械和设备修理业'
      }
    ]
  },
  {
    value: '4',
    label: '电力、热力、燃气及水生产和供应业',
    code: 'D',
    count: 0,
    industry: [
      {
        industryCode: '44',
        industryName: '电力、热力生产和供应业'
      },
      {
        industryCode: '45',
        industryName: '燃气生产和供应业'
      },
      {
        industryCode: '46',
        industryName: '水的生产和供应业'
      }
    ]
  },
  {
    value: '5',
    label: '建筑业',
    code: 'E',
    count: 0,
    industry: [
      {
        industryCode: '47',
        industryName: '房屋建筑业'
      },
      {
        industryCode: '48',
        industryName: '土木工程建筑业'
      },
      {
        industryCode: '49',
        industryName: '建筑安装业'
      },
      {
        industryCode: '50',
        industryName: '建筑装饰、装修和其他建筑业'
      }
    ]
  },
  {
    value: '6',
    label: '批发和零售业',
    code: 'F',
    count: 0,
    industry: [
      {
        industryCode: '51',
        industryName: '批发业'
      },
      {
        industryCode: '52',
        industryName: '零售业'
      }
    ]
  },
  {
    value: '7',
    label: '交通运输、仓储和邮政业',
    code: 'G',
    count: 0,
    industry: [
      {
        industryCode: '53',
        industryName: '铁路运输业'
      },
      {
        industryCode: '54',
        industryName: '道路运输业'
      },
      {
        industryCode: '55',
        industryName: '水上运输业'
      },
      {
        industryCode: '56',
        industryName: '航空运输业'
      },
      {
        industryCode: '57',
        industryName: '管道运输业'
      },
      {
        industryCode: '58',
        industryName: '多式联运和运输代理业'
      },
      {
        industryCode: '59',
        industryName: '装卸搬运和仓储业'
      },
      {
        industryCode: '60',
        industryName: '邮政业'
      }
    ]
  },
  {
    value: '8',
    label: '住宿和餐饮业',
    code: 'H',
    count: 0,
    industry: [
      {
        industryCode: '61',
        industryName: '住宿业'
      },
      {
        industryCode: '62',
        industryName: '餐饮业'
      }
    ]
  },
  {
    value: '9',
    label: '信息传输、软件和信息技术服务业',
    code: 'I',
    count: 0,
    industry: [
      {
        industryCode: '63',
        industryName: '电信、广播电视和卫星传输服务'
      },
      {
        industryCode: '64',
        industryName: '互联网和相关服务'
      },
      {
        industryCode: '65',
        industryName: '软件和信息技术服务业'
      }
    ]
  },
  {
    value: '10',
    label: '金融业',
    code: 'J',
    count: 0,
    industry: [
      {
        industryCode: '66',
        industryName: '货币金融服务'
      },
      {
        industryCode: '67',
        industryName: '资本市场服务'
      },
      {
        industryCode: '68',
        industryName: '保险业'
      },
      {
        industryCode: '69',
        industryName: '其他金融业'
      }
    ]
  },
  {
    value: '11',
    label: '房地产业',
    code: 'K',
    count: 0,
    industry: [
      {
        industryCode: '70',
        industryName: '房地产业'
      }
    ]
  },
  {
    value: '12',
    label: '租赁和商务服务业',
    code: 'L',
    count: 0,
    industry: [
      {
        industryCode: '71',
        industryName: '租赁业'
      },
      {
        industryCode: '72',
        industryName: '商务服务业'
      }
    ]
  },
  {
    value: '13',
    label: '科学研究和技术服务业',
    code: 'M',
    count: 0,
    industry: [
      {
        industryCode: '73',
        industryName: '研究和试验发展'
      },
      {
        industryCode: '74',
        industryName: '专业技术服务业'
      },
      {
        industryCode: '75',
        industryName: '科技推广和应用服务业'
      }
    ]
  },
  {
    value: '14',
    label: '水利、环境和公共设施管理业',
    code: 'N',
    count: 0,
    industry: [
      {
        industryCode: '76',
        industryName: '水利管理业'
      },
      {
        industryCode: '77',
        industryName: '生态保护和环境治理业'
      },
      {
        industryCode: '78',
        industryName: '公共设施管理业'
      },
      {
        industryCode: '79',
        industryName: '土地管理业'
      }
    ]
  },
  {
    value: '15',
    label: '居民服务、修理和其他服务业',
    code: 'O',
    count: 0,
    industry: [
      {
        industryCode: '80',
        industryName: '居民服务业'
      },
      {
        industryCode: '81',
        industryName: '机动车、电子产品和日用产品修理业'
      },
      {
        industryCode: '82',
        industryName: '其他服务业'
      }
    ]
  },
  {
    value: '16',
    label: '教育',
    code: 'P',
    count: 0,
    industry: [
      {
        industryCode: '83',
        industryName: '教育'
      }
    ]
  },
  {
    value: '17',
    label: '卫生和社会工作',
    code: 'Q',
    count: 0,
    industry: [
      {
        industryCode: '84',
        industryName: '卫生'
      },
      {
        industryCode: '85',
        industryName: '社会工作'
      }
    ]
  },
  {
    value: '18',
    label: '文化、体育和娱乐业',
    code: 'R',
    count: 0,
    industry: [
      {
        industryCode: '86',
        industryName: '新闻和出版业'
      },
      {
        industryCode: '87',
        industryName: '广播、电视、电影和录音制作业'
      },
      {
        industryCode: '88',
        industryName: '文化艺术业'
      },
      {
        industryCode: '89',
        industryName: '体育'
      },
      {
        industryCode: '90',
        industryName: '娱乐业'
      }
    ]
  },
  {
    value: '19',
    label: '公共管理、社会保障和社会组织',
    code: 'S',
    count: 0,
    industry: [
      {
        industryCode: '91',
        industryName: '中国共产党机关'
      },
      {
        industryCode: '92',
        industryName: '国家机构'
      },
      {
        industryCode: '93',
        industryName: '人民政协、民主党派'
      },
      {
        industryCode: '94',
        industryName: '社会保障'
      },
      {
        industryCode: '95',
        industryName: '群众团体、社会团体和其他成员组织'
      },
      {
        industryCode: '96',
        industryName: '基层群众自治组织及其他组织'
      }
    ]
  },
  {
    value: '20',
    label: '国际组织',
    code: 'T',
    count: 0,
    industry: [
      {
        industryCode: '97',
        industryName: '国际组织'
      }
    ]
  }
];
export const industrySecondClassifyToIndustry = {
  A: ['1', '2', '3', '4', '5'],
  B: ['6', '7', '8', '9', '10', '11', '12'],
  C: [
    '13',
    '14',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '40',
    '41',
    '42',
    '43'
  ],
  D: ['44', '45', '46'],
  E: ['47', '48', '49', '50'],
  F: ['51', '52'],
  G: ['53', '54', '55', '56', '57', '58', '59', '60'],
  H: ['61', '62'],
  I: ['63', '64', '65'],
  J: ['66', '67', '68', '69'],
  K: ['70'],
  L: ['71', '72'],
  M: ['73', '74', '75'],
  N: ['76', '77', '78', '79'],
  O: ['80', '81', '82'],
  P: ['83'],
  Q: ['84', '85'],
  R: ['86', '87', '88', '89', '90'],
  S: ['91', '92', '93', '94', '95', '96'],
  T: ['97']
};
export const industryArr = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T'
];

export const sortByMap = {
  '0': '默认排序',
  '1': '成立时间降序',
  '2': '成立时间升序',
  '3': '注册资本降序',
  '4': '注册资本升序'
};
export const enttypeMap = {
  '1': '民营',
  '2': '国有企业',
  '3': '外资、中外合资',
  '4': '港、澳、台投资',
  '5': '工商个体户',
  '7': '社会组织',
  '6': '其他企业'
};

export const enttypeMapTop = [
  // { key: 0, value: '全部' },
  { key: 1, value: '民营' },
  { key: 2, value: '国有企业' },
  { key: 3, value: '外资、中外合资' },
  { key: 4, value: '港、澳、台投资' },
  { key: 5, value: '工商个体户' },
  { key: 7, value: '社会组织' },
  { key: 6, value: '其他企业' }
];

export const employeesMap = [
  { key: '0', value: '不限' },
  { key: 1, value: '小于20人' },
  { key: 2, value: '20-50人' },
  { key: 3, value: '50-100人' },
  { key: 4, value: '100-500人' },
  { key: 5, value: '500-1000人' },
  { key: 6, value: '1000人以上' }
];

export const contactMap = [
  // { key: 0, value: '不限' },
  { key: 1, value: '有手机' },
  { key: 2, value: '有固话' },
  { key: 3, value: '有邮箱' },
  { key: 4, value: '有QQ' },
  { key: 5, value: '无联系方式' }
];

export const contactTypeList = {
  '0': '联系方式',
  '1': '手机',
  '2': '固话',
  '3': 'QQ',
  '4': '邮箱',
  '5': ''
};

export const openStatusMap = [
  // { key: 0, value: '不限' },
  { key: 1, value: '在营/存续' },
  { key: 4, value: '迁入/迁出' },
  { key: 2, value: '吊销/撤销' },
  { key: 3, value: '注销' },
  { key: 8, value: '停业' },
  { key: 9, value: '其他' }
];
export const sourceMap = [
  { id: 1, nameCn: '顺企', name: 'ShunQiCompany' },
  { id: 2, nameCn: '慧聪', name: 'HCCompany' },
  { id: 3, nameCn: '找找去', name: 'ZhaoZhaoQuCompany' },
  { id: 4, nameCn: '阿土伯', name: 'AtuboCompany' },
  { id: 5, nameCn: '环球贸易', name: 'HuanQiuCompany' },
  { id: 6, nameCn: '华风商务', name: 'HFSWCompany' },
  { id: 7, nameCn: '企领', name: 'QiLingWangCompany' },
  { id: 8, nameCn: '八方资源', name: 'b2b168Company' },
  { id: 9, nameCn: '企业梦工厂', name: 'MGCCompany' },
  // { id: 10, nameCn: '中国制造交易网', name: 'MadeInChinaProduct' },
  { id: 11, nameCn: '企业通', name: 'QiYeTongCompany' },
  { id: 12, nameCn: '58同城', name: '58Company' },
  { id: 13, nameCn: 'Hunt007', name: 'Hunt007Company' },
  { id: 14, nameCn: '51搜了么', name: '51SouleMaCompany' },
  { id: 15, nameCn: '黄页88', name: 'HuangYe88Company' },
  // { id: 16, nameCn: '中国网库', name: 'ChinaShopCompany' },
  { id: 17, nameCn: '马可波罗', name: 'MakepoloCompany' },
  { id: 18, nameCn: '传众', name: 'ChuanZhongCompany' },
  { id: 19, nameCn: '英才', name: 'YingcaiCompany' },
  { id: 20, nameCn: '赶集', name: 'GanJiWangCompany' },
  { id: 21, nameCn: '一呼百应', name: 'youboyCompany' },
  { id: 22, nameCn: '列表', name: 'LieBiaoWangCompany' },
  { id: 23, nameCn: '商务巴巴', name: 'SW88Company' },
  { id: 24, nameCn: '一比多', name: 'YiBiDuoCompany' },
  { id: 25, nameCn: '淘金地', name: 'TaoJinDiCompany' },
  { id: 26, nameCn: '阿里巴巴（1688）', name: '1688Company' },
  { id: 27, nameCn: '百度地图', name: 'BaiduDituCompany' },
  { id: 28, nameCn: '饿了么', name: 'ElemeCompany' },
  { id: 29, nameCn: '百度外卖', name: 'BaiDuWaiMai' },
  { id: 30, nameCn: '世界工厂', name: 'GongchangCompany' },
  { id: 31, nameCn: '中华企业录', name: 'ChinaQY6Company' },
  { id: 32, nameCn: '百度糯米', name: 'BaiDuNuoMiCompany' },
  { id: 33, nameCn: '中国制造', name: 'MadeInChinaProduct' },
  { id: 34, nameCn: '百度', name: 'BaiduCompany' },
  { id: 35, nameCn: '志趣', name: 'ZhiQuCompany' },
  { id: 36, nameCn: '258', name: '258Company' },
  { id: 37, nameCn: '百姓', name: 'BaiXingCompany' },
  { id: 38, nameCn: '快点8', name: 'QD8Company' },
  { id: 39, nameCn: 'K客集齐', name: 'KKeJiQi' },
  { id: 40, nameCn: '58建筑', name: '58GuaKao' },
  { id: 41, nameCn: '智联招聘', name: 'ZhiLianZhaopingCompany' },
  { id: 42, nameCn: '俊才招聘', name: 'JunCaiZhaopinCompany' },
  { id: 43, nameCn: '土巴兔', name: 'TuBaTuCompany' },
  { id: 44, nameCn: '中国纺织', name: 'ZhongGuoFangZhi' },
  { id: 45, nameCn: 'BOSS直聘', name: 'BossZhiPinKeyword' },
  { id: 46, nameCn: '京东B2B', name: 'JingDongCompany' },
  { id: 47, nameCn: '百度招聘', name: 'BaiduZhaopinCompany' },
  { id: 48, nameCn: '看准', name: 'KanzhunCompany' },
  { id: 49, nameCn: '英才招聘', name: 'YingcaiCompany' },
  { id: 50, nameCn: '36人才招聘', name: '36RencaiZhaopin' },
  { id: 51, nameCn: '大街', name: 'DajieCompany' },
  // { id: 52, nameCn: '职友集招聘', name: 'ZhiYouJiCompany' },
  { id: 53, nameCn: '51job招聘', name: '51JobCompany' },
  { id: 54, nameCn: '拉勾', name: 'LaGouCompany' },
  { id: 55, nameCn: '百大英才招聘', name: 'BaiDaCompany' },
  { id: 56, nameCn: '伯乐招聘', name: 'BLZPCompany' },
  { id: 57, nameCn: '1024商务', name: '1024SWCompany' },
  { id: 58, nameCn: '金安发', name: 'JinAnFaCompany' },
  // { id: 59, nameCn: '78挂靠', name: '78GuaKaoWang' },
  { id: 60, nameCn: '网商汇', name: 'WangShangHui' },
  { id: 61, nameCn: '玉环商务', name: 'YuHuanShangWu' },
  { id: 62, nameCn: '企业在线', name: 'QiyeZaixianCompany' },
  { id: 63, nameCn: '全天候贸易', name: 'QuanTianHouCompany' },
  { id: 64, nameCn: '利酷搜黄页', name: 'LiKuSoCompany' },
  { id: 65, nameCn: '中国商品', name: 'CNShangPinCompany' },
  { id: 66, nameCn: '亿商', name: 'YiShangWangCompany' },
  { id: 67, nameCn: '网络114', name: 'net114' },
  { id: 68, nameCn: '第1枪', name: 'DiYiQiangCompany' },
  { id: 69, nameCn: '际通宝', name: 'jitongbao' },
  { id: 70, nameCn: '酷易搜', name: 'KuYiSoCompany' },
  { id: 71, nameCn: '114百事通', name: 'BestCompany' },
  { id: 72, nameCn: '12580黄页', name: '12580HYCompany' },
  // { id: 73, nameCn: '中国纺织网', name: 'ZhongGuoFangZhi' },
  { id: 74, nameCn: '查电话', name: 'ChaDianHua' },
  { id: 75, nameCn: '会搜', name: 'HuiSouCompany' },
  { id: 76, nameCn: '比比', name: '' },
  { id: 77, nameCn: '产品', name: '' },
  { id: 78, nameCn: '虎易', name: '' },
  { id: 79, nameCn: '华律', name: '' },
  { id: 80, nameCn: '金泉', name: '' },
  { id: 81, nameCn: '康强', name: '' },
  { id: 82, nameCn: '买购', name: '' },
  { id: 83, nameCn: '企业库', name: '' },
  { id: 84, nameCn: '钱眼', name: '' },
  { id: 85, nameCn: '商虎中国', name: '' },
  { id: 86, nameCn: '生意宝', name: '' },
  { id: 87, nameCn: '中服', name: '' },
  { id: 88, nameCn: '中国供应商', name: '' },
  { id: 89, nameCn: '中国行业信息', name: '' },
  { id: 90, nameCn: '中国交易', name: '' },
  { id: 91, nameCn: '中国库', name: '' },
  { id: 92, nameCn: '爱喇叭', name: '' },
  { id: 93, nameCn: '百方', name: '' },
  { id: 94, nameCn: '环保在线', name: '' },
  { id: 95, nameCn: '巨潮资讯', name: '' },
  { id: 96, nameCn: '食品商务', name: '' },
  { id: 97, nameCn: '仪表仪器交易', name: '' },
  { id: 98, nameCn: '园林', name: '' },
  { id: 99, nameCn: '360', name: '' },
  { id: 100, nameCn: '广东公共资源', name: '' },
  { id: 101, nameCn: '互动百科', name: '' },
  { id: 102, nameCn: '搜狗', name: '' },
  { id: 103, nameCn: '114黄页', name: '' },
  { id: 104, nameCn: '黄页大全', name: '' },
  { id: 105, nameCn: '企业', name: '' },
  { id: 106, nameCn: '企业第一', name: '' },
  { id: 107, nameCn: '企业信息', name: '' },
  // { id: 108, nameCn: '中国企业在线', name: '' },
  { id: 109, nameCn: '企一', name: '' },
  { id: 110, nameCn: '同花顺', name: '' },
  { id: 111, nameCn: '知今黄页', name: '' },
  { id: 112, nameCn: '职友集', name: '' },
  { id: 113, nameCn: '中科商务', name: '' },
  // { id: 114, nameCn: '114百事通', name: '' },
  { id: 115, nameCn: '美团', name: '' },
  { id: 116, nameCn: '大众点评', name: '' },
  { id: 118, nameCn: '36人才', name: '' },
  { id: 119, nameCn: '全国公共交易采购平台', name: '' },
  { id: 120, nameCn: '优质采', name: '' },
  { id: 121, nameCn: '政府采购', name: '' },
  { id: 122, nameCn: '东方财富', name: '' }
  // { id: 123, nameCn: '2018年年报', name: '' },
  // { id: 124, nameCn: '2017年年报', name: '' },
  // { id: 125, nameCn: '2016年年报', name: '' },
  // { id: 126, nameCn: '2015年年报', name: '' },
  // { id: 127, nameCn: '2014年年报', name: '' },
  // { id: 128, nameCn: '2013年年报', name: '' }
];

export const scopeList = {
  companyname: '企业名称',
  products: '产品',
  businessscope: '经营范围',
  jobtitle: '招聘职位',
  semkeyword: '网络推广',
  guanwang: '网站名称',
  shangbiao: '商标',
  zhuanli: '专利',
  auction: '招标投标',
  address: '地址',
  trademarkName: '商标',
  patentName: '专利',
  certL2Name: '证书'
};
export const sourceMapClass = [
  // 年报根据产品需求不按照字母排序，将优先级放置第一
  {
    value: '10',
    label: '年报',
    code: 'J',
    count: 0,
    sourceName: [
      { id: 123, nameCn: '2018年年报', name: '' },
      { id: 124, nameCn: '2017年年报', name: '' },
      { id: 125, nameCn: '2016年年报', name: '' },
      { id: 126, nameCn: '2015年年报', name: '' },
      { id: 127, nameCn: '2014年年报', name: '' }
    ]
  },
  {
    value: '1',
    label: 'B2B',
    code: 'A',
    count: 0,
    sourceName: [
      {
        id: 57,
        name: '1024SWCompany',
        nameCn: '1024商务'
      },
      {
        id: 36,
        nameCn: '258',
        name: '258Company'
      },
      {
        id: 14,
        nameCn: '51搜了么',
        name: '51SouleMaCompany'
      },
      {
        id: 26,
        name: '1688Company',
        nameCn: '阿里巴巴（1688）'
      },
      { id: 8, nameCn: '八方资源', name: 'b2b168Company' },
      { id: 76, nameCn: '比比', name: '' },
      { id: 77, nameCn: '产品', name: '' },
      { id: 18, nameCn: '传众', name: 'ChuanZhongCompany' },
      { id: 68, nameCn: '第1枪', name: 'DiYiQiangCompany' },
      { id: 4, nameCn: '阿土伯', name: 'AtuboCompany' },
      { id: 78, nameCn: '虎易', name: '' },
      { id: 6, nameCn: '华风商务', name: 'HFSWCompany' },
      { id: 79, nameCn: '华律', name: '' },
      { id: 5, nameCn: '环球贸易', name: 'HuanQiuCompany' },
      { id: 2, nameCn: '慧聪', name: 'HCCompany' },
      { id: 75, nameCn: '会搜', name: 'HuiSouCompany' },
      { id: 69, nameCn: '际通宝', name: 'jitongbao' },
      { id: 58, nameCn: '金安发', name: 'JinAnFaCompany' },
      { id: 80, nameCn: '金泉', name: '' },
      { id: 46, nameCn: '京东B2B', name: 'JingDongCompany' },
      { id: 39, nameCn: 'K客集齐', name: 'KKeJiQi' },
      { id: 81, nameCn: '康强', name: '' },
      { id: 70, nameCn: '酷易搜', name: 'KuYiSoCompany' },
      { id: 38, nameCn: '快点8', name: 'QD8Company' },
      { id: 17, nameCn: '马可波罗', name: 'MakepoloCompany' },
      { id: 82, nameCn: '买购', name: '' },
      { id: 7, nameCn: '企领', name: 'QiLingWangCompany' },
      { id: 83, nameCn: '企业库', name: '' },
      { id: 9, nameCn: '企业梦工厂', name: 'MGCCompany' },
      { id: 11, nameCn: '企业通', name: 'QiYeTongCompany' },
      { id: 84, nameCn: '钱眼', name: '' },
      { id: 63, nameCn: '全天候贸易', name: 'QuanTianHouCompany' },
      { id: 85, nameCn: '商虎中国', name: '' },
      { id: 23, nameCn: '商务巴巴', name: 'SW88Company' },
      { id: 86, nameCn: '生意宝', name: '' },
      { id: 30, nameCn: '世界工厂', name: 'GongchangCompany' },
      { id: 25, nameCn: '淘金地', name: 'TaoJinDiCompany' },
      { id: 60, nameCn: '网商汇', name: 'WangShangHui' },
      { id: 24, nameCn: '一比多', name: 'YiBiDuoCompany' },
      { id: 21, nameCn: '一呼百应', name: 'youboyCompany' },
      { id: 66, nameCn: '亿商', name: 'YiShangWangCompany' },
      { id: 61, nameCn: '玉环商务', name: 'YuHuanShangWu' },
      { id: 3, nameCn: '找找去', name: 'ZhaoZhaoQuCompany' },
      { id: 35, nameCn: '志趣', name: 'ZhiQuCompany' },
      { id: 87, nameCn: '中服', name: '' },
      { id: 88, nameCn: '中国供应商', name: '' },
      { id: 89, nameCn: '中国行业信息', name: '' },
      { id: 90, nameCn: '中国交易', name: '' },
      { id: 91, nameCn: '中国库', name: '' },
      { id: 65, nameCn: '中国商品', name: 'CNShangPinCompany' },
      { id: 33, nameCn: '中国制造', name: 'MadeInChinaProduct' }
    ]
  },
  {
    value: '2',
    label: '垂直门户',
    code: 'B',
    count: 0,
    sourceName: [
      { id: 40, nameCn: '58建筑', name: '58GuaKao' },
      { id: 92, nameCn: '爱喇叭', name: '' },
      { id: 93, nameCn: '百方', name: '' },
      { id: 94, nameCn: '环保在线', name: '' },
      { id: 95, nameCn: '巨潮资讯', name: '' },
      { id: 96, nameCn: '食品商务', name: '' },
      { id: 43, nameCn: '土巴兔', name: 'TuBaTuCompany' },
      { id: 97, nameCn: '仪表仪器交易', name: '' },
      { id: 98, nameCn: '园林', name: '' },
      { id: 44, nameCn: '中国纺织', name: 'ZhongGuoFangZhi' }
    ]
  },
  {
    value: '3',
    label: '地图',
    code: 'C',
    count: 0,
    sourceName: [{ id: 27, nameCn: '百度地图', name: 'BaiduDituCompany' }]
  },
  {
    value: '4',
    label: '分类信息',
    code: 'D',
    count: 0,
    sourceName: [
      { id: 99, nameCn: '360', name: '' },
      { id: 12, nameCn: '58同城', name: '58Company' },
      { id: 34, nameCn: '百度', name: 'BaiduCompany' },
      { id: 37, nameCn: '百姓', name: 'BaiXingCompany' },
      { id: 20, nameCn: '赶集', name: 'GanJiWangCompany' },
      { id: 100, nameCn: '广东公共资源', name: '' },
      { id: 101, nameCn: '互动百科', name: '' },
      { id: 22, nameCn: '列表', name: 'LieBiaoWangCompany' },
      { id: 102, nameCn: '搜狗', name: '' }
    ]
  },
  {
    value: '5',
    label: '企业信息',
    code: 'E',
    count: 0,
    sourceName: [
      { id: 103, nameCn: '114黄页', name: '' },
      { id: 72, nameCn: '12580黄页', name: '12580HYCompany' },
      { id: 15, nameCn: '黄页88', name: 'HuangYe88Company' },
      { id: 104, nameCn: '黄页大全', name: '' },
      { id: 64, nameCn: '利酷搜黄页', name: 'LiKuSoCompany' },
      { id: 105, nameCn: '企业', name: '' },
      { id: 106, nameCn: '企业第一', name: '' },
      { id: 107, nameCn: '企业信息', name: '' },
      { id: 109, nameCn: '企一', name: '' },
      { id: 62, nameCn: '企业在线', name: 'QiyeZaixianCompany' },
      { id: 1, nameCn: '顺企网', name: 'ShunQiCompany' },
      { id: 110, nameCn: '同花顺', name: '' },
      { id: 67, nameCn: '网络114', name: 'net114' },
      { id: 111, nameCn: '知今黄页', name: '' },
      { id: 112, nameCn: '职友集', name: '' },
      { id: 31, nameCn: '中华企业录', name: 'ChinaQY6Company' },
      { id: 113, nameCn: '中科商务', name: '' }
    ]
  },
  {
    value: '6',
    label: '生活服务',
    code: 'F',
    count: 0,
    sourceName: [
      { id: 71, nameCn: '114百事通', name: 'BestCompany' },
      { id: 32, nameCn: '百度糯米', name: 'BaiDuNuoMiCompany' },
      { id: 29, nameCn: '百度外卖', name: 'BaiDuWaiMai' },
      { id: 74, nameCn: '查电话', name: 'ChaDianHua' },
      { id: 116, nameCn: '大众点评', name: '' },
      { id: 28, nameCn: '饿了么', name: 'ElemeCompany' },
      { id: 115, nameCn: '美团', name: '' }
    ]
  },
  {
    value: '7',
    label: '招聘',
    code: 'G',
    count: 0,
    sourceName: [
      { id: 118, nameCn: '36人才', name: '' },
      { id: 50, nameCn: '36人才招聘', name: '36RencaiZhaopin' },
      { id: 53, nameCn: '51job招聘', name: '51JobCompany' },
      { id: 55, nameCn: '百大英才招聘', name: 'BaiDaCompany' },
      { id: 47, nameCn: '百度招聘', name: 'BaiduZhaopinCompany' },
      { id: 56, nameCn: '伯乐招聘', name: 'BLZPCompany' },
      { id: 45, nameCn: 'BOSS直聘', name: 'BossZhiPinKeyword' },
      { id: 13, nameCn: 'Hunt007', name: 'Hunt007Company' },
      { id: 51, nameCn: '大街', name: 'DajieCompany' },
      { id: 42, nameCn: '俊才招聘', name: 'JunCaiZhaopinCompany' },
      { id: 48, nameCn: '看准', name: 'KanzhunCompany' },
      { id: 54, nameCn: '拉勾', name: 'LaGouCompany' },
      { id: 19, nameCn: '英才', name: 'YingcaiCompany' },
      { id: 49, nameCn: '英才招聘', name: 'YingcaiCompany' },
      { id: 41, nameCn: '智联招聘', name: 'ZhiLianZhaopingCompany' }
    ]
  },
  {
    value: '8',
    label: '招投标',
    code: 'H',
    count: 0,
    sourceName: [
      { id: 119, nameCn: '全国公共交易采购平台', name: '' },
      { id: 120, nameCn: '优质采', name: '' },
      { id: 121, nameCn: '政府采购', name: '' }
    ]
  },
  {
    value: '9',
    label: '资讯',
    code: 'I',
    count: 0,
    sourceName: [{ id: 122, nameCn: '东方财富', name: '' }]
  }
];



// WEBPACK FOOTER //
// ./src/common/optionMap.js